module.exports = __webpack_public_path__ + "img/fila-logo.087c3cda.svg";